import React from 'react';
import { P, makeStyles } from '@hummingbirdtechgroup/wings-ui';
const useStyles = makeStyles(() => ({
    '@keyframes fade-in': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    root: {
        animation: '$fade-in 0.2s 1',
    },
}));
const ValidationMessage = ({ children }) => {
    const classes = useStyles();
    return (React.createElement(P, { className: classes.root, theme: "error" }, children));
};
export default ValidationMessage;
//# sourceMappingURL=ValidationMessage.js.map